import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.isRestoring = false

    this.onVisibilityChange = () => {
      if (this.isRestoring) return
      if (document.hidden) return

      const chartElements = document.querySelectorAll("[id^='chart-']")
      const hasCharts = chartElements.length > 0
      const initializedCharts = window.Chartkick?.charts
      const hasInitializedCharts = initializedCharts && Object.keys(initializedCharts).length > 0

      // After iOS background/foreground transitions, chart DOM can return without re-running inline Chartkick scripts.
      if (hasCharts && !hasInitializedCharts) {
        this.restore()
      }
    }

    this.onPageShow = (e) => {
      if (this.isRestoring) return
      const entries = window.performance.getEntriesByType("navigation")
      const navigationType = entries.length ? entries[0].type : null
      const didRestoreHistory = e.persisted || navigationType === "back_forward"

      if (didRestoreHistory) {
        this.restore()
      }
    }

    this.restore = () => {
      this.isRestoring = true
      window.Turbo.visit(window.location.href, { action: "replace" })
      window.setTimeout(() => { this.isRestoring = false }, 1200)
    }

    window.addEventListener("pageshow", this.onPageShow)
    document.addEventListener("visibilitychange", this.onVisibilityChange)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.onPageShow)
    document.removeEventListener("visibilitychange", this.onVisibilityChange)
  }
}
